// extracted by mini-css-extract-plugin
module.exports = {"carousel":"_1p1Ttm"};